export default function SectionContact() {
  return (
    <section id="contact" className="bg-background-100 py-16 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-xl border border-background-200/70 p-8 md:p-10 text-center">
          <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-100 mx-auto mb-5">
            <i className="ri-mail-send-line text-primary-600 text-2xl"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto mb-6 leading-relaxed">
            如果你有影片资源建议、合作意向或任何问题反馈，欢迎通过以下方式与我们取得联系。我们珍视每一位影迷的声音。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <div className="flex items-center gap-2 px-4 py-2 bg-background-100 rounded-lg">
              <i className="ri-mail-line text-primary-500"></i>
              <span className="text-foreground-700 text-sm">contact@7777cinema.com</span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 bg-background-100 rounded-lg">
              <i className="ri-wechat-line text-green-500"></i>
              <span className="text-foreground-700 text-sm">7777影迷服务号</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}